import { Injectable } from "@angular/core";
import { InternationalCatalogsType } from "@app/public/international-catalogs/international-catalogs.service";
import { BreadcrumbType } from "@enums/breadcrumbType";
import { CatalogLanguage } from "@interfaces/HttpClient/CatalogApiPublicModels";
import { IBreadcrumb } from "@interfaces/iBreadcrumb";
import { ISearchResultsParams } from "@interfaces/iSearchResultsParams";
import { GlobalVarService } from "./global-var.service";

@Injectable()
export class BreadcrumbService {
	constructor(private globalVarService: GlobalVarService) { }

	public getStartpage(): IBreadcrumb {
		return {
			key: "breadcrumb.startpage",
			routerLink: "/",
			breadcrumbType: BreadcrumbType.Startpage
		};
	}

	public getAz(): IBreadcrumb {
		return {
			key: "breadcrumb.a-z",
			routerLink: "/a-z",
			breadcrumbType: BreadcrumbType.Az
		};
	}

	public setInternationalCatalogsNavigation(
		internationalCatalogsType?: InternationalCatalogsType,
		catalogLanguage?: CatalogLanguage,
	) {
		this.setCatalogNavigation(this.getInternationalCatalogs(internationalCatalogsType, catalogLanguage))
	}

	public getInternationalCatalogs(
		internationalCatalogsType?: InternationalCatalogsType,
		catalogLanguage?: CatalogLanguage,

	): IBreadcrumb {

		return {
			key: "breadcrumb.international-catalogs",
			routerLink: "/international-catalogs",
			queryParams: {
				type: internationalCatalogsType,
				language: catalogLanguage
			},
			breadcrumbType: BreadcrumbType.InternationalCatalogs
		};
	}

	public setCatalogCategoryNavigation(
		categoryGroupId: number,
		categoryId: number,
		categoryGroupName: string
	) {
		this.setCatalogNavigation(this.getCategory(categoryGroupId, categoryId, categoryGroupName));
	}

	public getCategory(
		categoryGroupId: number,
		categoryId: number,
		categoryGroupName: string
	): IBreadcrumb {
		return {
			key: "breadcrumb.category",
			routerLink: "/category",
			queryParams: {
				categoryGroup: categoryGroupId,
				category: categoryId
			},
			text: categoryGroupName,
			breadcrumbType: BreadcrumbType.Category
		};
	}

	public getSearch(searchParams: ISearchResultsParams): IBreadcrumb {
		return {
			key: "breadcrumb.search",
			routerLink: "/search",
			queryParams: searchParams,
			breadcrumbType: BreadcrumbType.Search
		};
	}

	public getCatalog(catalogName: string, catalogKey: string): IBreadcrumb {
		return {
			text: catalogName,
			routerLink: "/catalog/" + catalogKey,
			breadcrumbType: BreadcrumbType.Catalog
		};
	}

	public setCatalogNavigation(iBreadcrumb: IBreadcrumb) {
		this.globalVarService.setCatalogNavigation(JSON.stringify(iBreadcrumb));
	}

	public setSearchNavigation(iBreadcrumb: IBreadcrumb) {
		this.globalVarService.setSearchNavigation(JSON.stringify(iBreadcrumb));
	}

	public getCatalogNavigation(): IBreadcrumb {
		const searchmarker = this.globalVarService.getCatalogNavigation();
		if (searchmarker?.length > 0 && searchmarker !== "undefined") {
			return JSON.parse(searchmarker);
		}
	}

	public getSearchNavigation(): IBreadcrumb {
		const searchmarker = this.globalVarService.getSearchNavigation();
		if (searchmarker?.length > 0 && searchmarker !== "undefined") {
			return JSON.parse(searchmarker);
		}
	}
}
